var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.view,{tag:"component",scopedSlots:_vm._u([{key:"header",fn:function(){return [_vm._t("header")]},proxy:true}],null,true)},[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }